import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ToolsService } from '../../../services/tools/tools.service';
import { Column } from '../../interfaces/column.interface';
import { DialogCguFormComponent } from './cgu-form/cgu-form.component';
import { DialogCguDetailsComponent } from './cgu-details/cgu-details.component';
import { CgusDataService } from '../../services/cgus-data.service';
import { Cgu, CgusResult } from '../../interfaces/cgu.interface';
import { CgusColumnsService } from '../../services/cgus-columns.service';

@Component({
  selector: 'app-cgu-sessions',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss'],
  providers: [MessageService, ConfirmationService, DialogService],
})
export class CguComponent implements OnInit, OnDestroy {

  private cguAddDialog: DynamicDialogRef = new DynamicDialogRef();
  private cguEditDialog: DynamicDialogRef = new DynamicDialogRef();
  private cguDetailsDialog: DynamicDialogRef = new DynamicDialogRef();
  public cguToDelete: Cgu = {};
  public cgus: Cgu[] = [];
  public columns: Column[] = [];
  public isLoading: boolean = false;
  public isInitialized: boolean = false;
  private _selectedColumns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private cgusDataService: CgusDataService,
    private cgusColumnsService: CgusColumnsService,
  ) {
  }

  ngOnInit(): void {
    this.isInitialized = true;
    this.titleService.setTitle('cgus - Management');
    this.primengConfig.ripple = true;
    this.getCgus();
  }

  ngOnDestroy(): void {
    this.isInitialized = false;
  }
 
  getCgus(): void {
    this.isLoading = true;
    if (!this.isInitialized) {
      return;
    }
    this.cgusDataService.getCgus().subscribe((response: CgusResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.setColumns();
        this.cgus = response.success.data;
      }
    }, (error: any) => {;
      this.isLoading = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.CguSNOTLOADED')});
    });
  }

  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.cgusColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }

  @Input()
  get selectedColumns(): any[] {
      return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
      // restore original order
      this._selectedColumns = this.columns.filter((col: any) => val.includes(col));
      this.updateColumns();
  }

  updateColumns() {
    for (let i = 0; i < this.columns.length; i++) {
      const show = this._selectedColumns.includes(this.columns[i]);
      this.columns[i].show = show;
      this.navigation.setParamValue('cgu.' + this.columns[i].field + '.showFiled', show);
    }
  }

  exportPdf() {
    ToolsService.exportPdf(this.cgus, this.columns, 'cgus');
  }

  exportExcel() {
    ToolsService.exportExcel(this.cgus, this.columns, 'cgus');
  }

  exportCsv() {
    ToolsService.exportCsv(this.cgus, this.columns, 'cgus');
  }

  refresh() {
    this.getCgus();
  }

  CguAdd(): void {
    if (!this.navigation.getParamValue('cgu.addInDialog', true)) {
      this.router.navigate(['/cgus/add']);
      return;
    }
    this.cguAddDialog = this.dialogService.open(DialogCguFormComponent, {
      header: '', // this.translate.instant('NEWCgu'),
      width: '80%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'add',
        cgu: {id: null},
        cguClasses: this.cgusColumnsService.cguClasses,
        coaches: this.cgusColumnsService.coaches,
        users: this.cgusColumnsService.users,
      },
    });

    this.cguAddDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'cgu added'});
        this.getCgus();
      }
    });
  }

  CguEdit(cgu: Cgu): void {
    if (!this.navigation.getParamValue('cgu.editInDialog', true)) {
      this.router.navigate(['/cgus/edit/' + cgu.id]);
      return;
    }
    this.cguEditDialog = this.dialogService.open(DialogCguFormComponent, {
      header: '', // this.translate.instant('EDITCgu') + ' ' + Cgu.name,
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'edit',
        cgu: cgu,
        cguClasses: this.cgusColumnsService.cguClasses,
        coaches: this.cgusColumnsService.coaches,
        users: this.cgusColumnsService.users,
      },
    });

    this.cguEditDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'cgus updated'});
        this.getCgus();
      }
    });
  }

  cguDetails(cgu: Cgu): void {
    if (!this.navigation.getParamValue('cgu.detailsInDialog', true)) {
      this.router.navigate(['/cgus/details/' + cgu.id]);
      return;
    }
    this.cguDetailsDialog = this.dialogService.open(DialogCguDetailsComponent, {
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        cgu: cgu,
      }
    });
  }




  

}
